import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIcWallet1NavOl = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Layer_1",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 32 32",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: "\n      .st0 {\n        fill: #d8161f;\n      }\n    " }) }),
		/* @__PURE__ */ _jsx("path", {
			className: "st0",
			d: "M32,5c0,2.8-2.2,5-5,5s-3.6-1.1-4.5-2.7c-.2-.4-.3-.8-.4-1.2,0-.3-.1-.7-.1-1s0,0,0,0c0-.9.2-1.7.7-2.4C23.5,1,25.2,0,27,0,29.8,0,32,2.2,32,5Z"
		}),
		/* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("path", { d: "M29.1,12.7c-.7.2-1.4.3-2.1.3h-.1c.3.4.5.8.5,1.3v11.1c0,1.2-1,2.1-2.1,2.1H7.8c-1.2,0-2.1-1-2.1-2.1v-11.1c0-1.2,1-2.1,2.1-2.1h15.6c-1-.5-1.9-1.2-2.6-2.1H7.8c-.6,0-1.2.1-1.8.4.3-.7.8-1.3,1.3-1.4l11.7-3.9h0c0-.9.1-1.6.3-2.3L6.6,7c-1.7.7-3,2.9-3,5.1v2.2h0v11.1c0,2.3,1.9,4.2,4.2,4.2h17.4c2.3,0,4.2-1.9,4.2-4.2v-11.1c0-.6-.1-1.1-.3-1.6Z" }), /* @__PURE__ */ _jsx("path", { d: "M21.3,19.8c0,1,.8,1.8,1.8,1.8s1.8-.8,1.8-1.8-.8-1.8-1.8-1.8-1.8.8-1.8,1.8Z" })] })
	]
});
export default SvgIcWallet1NavOl;
